module.exports = __webpack_public_path__ + "img/c01_unitbatteringram_Normal_ua.dcacff06.webp";